import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import FloatingDemoButton from './components/FloatingDemoButton';
import Home from './pages/Home';
import About from './pages/About';
import Solutions from './pages/Solutions';
import Products from './pages/Products';
import GIRMP from './pages/GIRMP';
import CapitalRequest from './pages/CapitalRequest';
import SubmitRequest from './pages/SubmitRequest';
import Contact from './pages/Contact';
import NotFound from './pages/NotFound';

function AppContent() {
  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      
      <main className="flex-grow">
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/solutions" element={<Solutions />} />
          <Route path="/products" element={<Products />} />
          <Route path="/products/girmp" element={<GIRMP />} />
          <Route path="/capital-request" element={<CapitalRequest />} />
          <Route path="/submit-request" element={<SubmitRequest />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>

      <FloatingDemoButton />
      <Footer />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;
